
import { useApplicationStatusUpdater } from "./useApplicationStatusUpdater";
import { useApplicationDeleter } from "./useApplicationDeleter";
import { useExpertUnpublisher } from "./useExpertUnpublisher";

interface ExpertApplication {
  id: string;
  user_id: string | null;
  full_name: string;
  email: string;
  phone: string | null;
  professional_title: string;
  years_experience: number;
  specializations: string[];
  bio: string;
  hourly_rate: number;
  linkedin_url: string | null;
  website_url: string | null;
  motivation_letter: string | null;
  status: 'pending' | 'approved' | 'rejected';
  admin_notes: string | null;
  reviewed_by: string | null;
  reviewed_at: string | null;
  created_at: string;
  updated_at: string;
}

export function useExpertApplicationActions(onRefresh: () => void) {
  const { handleStatusUpdate } = useApplicationStatusUpdater(onRefresh);
  const { handleDeleteApplication } = useApplicationDeleter(onRefresh);
  const { handleUnpublishExpert } = useExpertUnpublisher(onRefresh);

  return {
    handleStatusUpdate,
    handleDeleteApplication,
    handleUnpublishExpert
  };
}
